import { render } from "./TacticContextFilter.vue?vue&type=template&id=32bc5ae7&scoped=true"
import script from "./TacticContextFilter.vue?vue&type=script&lang=js"
export * from "./TacticContextFilter.vue?vue&type=script&lang=js"

import "./TacticContextFilter.vue?vue&type=style&index=0&id=32bc5ae7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bc5ae7"]])

export default __exports__